/**
 * Appointment API JavaScript
 * Handles API calls and data fetching for appointments
 */

// API functions
const API_BASE = window.EXT_API_BASE_URL || 'https://ext-t-extapi.llsa.cloud';
async function fetchScreeningsByZip(zipCode, radius = 50) {
    try {
        const response = await fetch(
            `${API_BASE}/api/ecom/screeningsearch?zip=${zipCode}&radius=${radius}`,
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        // Check for restricted appointment states
        let hasRestrictedState = false;
        if (data && Array.isArray(data) && window.RESTRICTED_STATES) {
            hasRestrictedState = data.some((screening) => {
                return screening.state && window.RESTRICTED_STATES.includes(screening.state);
            });
        }

        // Set global flag for restricted states
        window.hasRestrictedStates = hasRestrictedState;

        return data;
    } catch (error) {
        throw error;
    }
}

/**
 * @param {any} appointmentCellGuid
 * @param {any} sessionId
 */
async function lockAppointment(appointmentCellGuid, sessionId) {
    const url = `${API_BASE}/api/ecom/lockAppointment?session=${sessionId}&cell=${appointmentCellGuid}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Failed to lock appointment:', error);
        throw error;
    }
}

// Data processing functions
function sortScreenings(screenings, sortBy = 'distance') {
    if (!screenings || screenings.length === 0) return screenings;

    const sortedScreenings = [...screenings];

    if (sortBy === 'distance') {
        // Sort by distance (ascending - closest first)
        sortedScreenings.sort((a, b) => {
            // Handle null/undefined/empty values properly
            const distanceA =
                a.distanceAway !== null && a.distanceAway !== undefined
                    ? parseFloat(a.distanceAway)
                    : 999999;
            const distanceB =
                b.distanceAway !== null && b.distanceAway !== undefined
                    ? parseFloat(b.distanceAway)
                    : 999999;

            // Ensure NaN values are treated as far away
            const finalDistanceA = isNaN(distanceA) ? 999999 : distanceA;
            const finalDistanceB = isNaN(distanceB) ? 999999 : distanceB;

            return finalDistanceA - finalDistanceB;
        });
    } else if (sortBy === 'date') {
        // Sort by date (ascending - earliest first)
        sortedScreenings.sort((a, b) => {
            const dateA = new Date(a.screeningDate || '9999-12-31');
            const dateB = new Date(b.screeningDate || '9999-12-31');
            return dateA - dateB;
        });
    }

    return sortedScreenings;
}
